// 定义中文语言包对象
export default {
  bigScreen: {
    品河线锯数字化智能监控系统: "品河线锯数字化智能监控系统",
    在线设备数: "在线设备数",
    设备数: "设备数",
    异常设备: "异常设备",
    正常设备: "正常设备",
    切割统计: "切割统计",
    切割耗线量: "切割耗线量",
    耗线量: "耗线量",
    切割荒料量: "切割荒料量",
    荒料量: "荒料量",
    切割平方数: "切割平方数",
    在线设备列表: "在线设备列表",
    序号: "序号",
    客户名称: "客户名称",
    型号: "型号",
    编号: "编号",
    工作状态: "工作状态",
    更新时间: "更新时间",
    磊扬石材: "磊扬石材",
    汉艺石业: "汉艺石业",
    澳文洲石业: "澳文洲石业",
    百辰中宇石业: "百辰中宇石业",
    开机: "开机",
    报警: "报警",
    关机: "关机",
    实时切割视频: "实时切割视频",
    实时监控视频: "实时监控视频",
    暂无监控视频: "暂无监控视频",
    暂无数据: "暂无数据",
    报警统计: "报警统计",
    传感器故障: "传感器故障",
    电机故障: "电机故障",
    导轨故障: "导轨故障",
    轴箱故障: "轴箱故障",
    断线: "断线",
    "湾流-G2034": "湾流-G2034",
    "飞流-G2034": "飞流-G2034",
    单位: "单位",
    万: "万",
    个: "个",
    台: "台",
    更多: "更多",
    查看全部数据: "查看全部数据",
    月: "月",
    一月: "1月",
    二月: "2月",
    三月: "3月",
    四月: "4月",
    五月: "5月",
    六月: "6月",
    七月: "7月",
    八月: "8月",
    九月: "9月",
    十月: "10月",
    十一月: "11月",
    十二月: "12月",
    语种: "语种",
  },
  detailScreen: {
    切割时间统计: "切割时间统计",
    切割剩余时间: "切割剩余时间",
    切割开始时间: "切割开始时间",
    预计结束时间: "预计结束时间",
    完成率: "完成率",
    剩余时间: "剩余时间",
    切割配方: "切割配方",
    更多数据: "更多数据",
    当前步数: "当前步数",
    进给位置: "进给位置",
    送线长度: "送线长度",
    进给速度: "进给速度",
    线速度: "线速度",
    回线长度: "回线长度",
    轴曲线区域: "轴曲线区域",
    速度: "速度",
    扭矩: "扭矩",
    电机温度: "电机温度",
    主轴箱温度: "主轴箱温度",
    副轴箱温度: "副轴箱温度",
    切割状态: "切割状态",
    热机完成: "热机完成",
    当前切割配方: "当前切割配方",
    当前切割配方数据: "当前切割配方数据",
    报警: "报警",
    轴报警: "轴报警",
    耗电量: "耗电量",
    切割平方数: "切割平方数",
    左升降: "左升降",
    右升降: "右升降",
    主轴2: "主轴2",
    主轴1: "主轴1",
    主轴3: "主轴3",
    主轴4: "主轴4",
    左张力: "左张力",
    右张力: "右张力",
    左排线: "左排线",
    右排线: "右排线",
    左线轮: "左线轮",
    右线轮: "右线轮",
    正常: "正常",
    异常: "异常",
    耗材管理: "耗材管理",
    罗拉使用时间: "罗拉使用时间",
    主轴箱使用时间: "主轴箱使用时间",
    副轴箱使用时间: "副轴箱使用时间",
    实时视频: "实时视频",
    实时监控视频: "实时监控视频",
    度: "度",
    详情: "详情",
    状态: "状态",
    故障代码: "故障代码",
    无: "无",
    运动: "运动",
    静止: "静止",
    正在解除: "正在解除",
    停止: "停止",
    正在开始: "正在开始",
    准备就绪: "准备就绪",
    叠加: "叠加",
    运行: "运行",
    正在停止: "正在停止",
    正在急停: "正在急停",
    急停: "急停",
    正在暂停: "正在暂停",
    暂停: "暂停",
    解除暂停: "解除暂停",
    正在叠加: "正在叠加",
    解除叠加: "解除叠加",
    正在复位: "正在复位",
    正在完成: "正在完成",
    完成: "完成",
    步骤: "步骤",
    设备树: "设备树",
    返回: "返回",
  },
};
